<script setup lang="ts">
import { useLayout } from "@/composables/layout/use-layout";

import ProgressSpinner from "primevue/progressspinner";

const { isGlobalLoading } = useLayout();
</script>

<template>
  <div
    v-if="isGlobalLoading"
    class="fixed top-0 bottom-0 right-0 left-0 z-50 back-blur"
  >
    <div class="absolute h-full w-full">
      <div class="h-full w-full flex justify-center items-center">
        <ProgressSpinner />
      </div>
    </div>
    <div class="h-full w-full bg-white opacity-30" />
  </div>
</template>
